import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'sbb-app',
  imports: [RouterOutlet],
  templateUrl: './app.html',
})
export class App {}
